import type { Account, SourceAccount } from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';

import { TextDetailsTuple } from '../text/textDetailsTuple';

export const AccountIndicator = ({
  account,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
  copyable = true,
}: {
  account: Account | SourceAccount;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
  copyable?: boolean;
}) => {
  const cloudProvider =
    'cloudProvider' in account
      ? account.cloudProvider
      : account.sourceAccountAttributes.cloudProvider;

  return showCloudIndicator ? (
    <CloudProviderIndicator
      cloudProvider={cloudProvider}
      text={
        <Tuple
          showAccountName={showAccountName}
          showAccountId={showAccountId}
          account={account}
          copyable={copyable}
        />
      }
    />
  ) : (
    <Tuple
      showAccountName={showAccountName}
      showAccountId={showAccountId}
      account={account}
      copyable={copyable}
    />
  );
};

const Tuple = ({
  showAccountName,
  showAccountId,
  account,
  copyable = true,
}: {
  showAccountName?: boolean;
  showAccountId?: boolean;
  account: Account | SourceAccount;
  copyable?: boolean;
}) => {
  return (
    <TextDetailsTuple
      primaryProp={showAccountName ? account.name : undefined}
      secondaryProp={showAccountId ? account.providerAccountId : undefined}
      copyable={copyable}
    />
  );
};
